// 긴 텍스트 영역을 line-clamp로 자르고 "더보기"/"접기" 토글.
// 사용:
//   <div data-controller="expandable">
//     <div data-expandable-target="content" class="line-clamp-3">...</div>
//     <button data-action="click->expandable#toggle"
//             data-expandable-target="button">더보기</button>
//   </div>
//
// connect 시 실제로 잘렸는지(scrollHeight > clientHeight) 검사해 잘리지
// 않았으면 버튼 자체를 숨김 (짧은 텍스트일 때 의미 없는 버튼 안 보이게).
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "button"]

  connect() {
    if (!this.hasContentTarget || !this.hasButtonTarget) return
    const overflows = this.contentTarget.scrollHeight > this.contentTarget.clientHeight + 1
    if (!overflows) this.buttonTarget.classList.add("hidden")
  }

  toggle() {
    const isClamped = this.contentTarget.classList.toggle("line-clamp-3")
    if (this.hasButtonTarget) {
      this.buttonTarget.textContent = isClamped ? "더보기" : "접기"
    }
  }
}
